export default (centPrice?: number) => {
    if(!centPrice) {
        return ''
    }
    let { currencyPrefix, currencySuffix, currencyThousand } = globalThis.locale;
    
    let decimal = centPrice/100
    let text = decimal.toFixed(0)
    text = text.replace(/\B(?=(\d{3})+(?!\d))/g, currencyThousand);
    
    if(currencyPrefix) {
        text = currencyPrefix+text
    }
    if(currencySuffix) {
        text = text+currencySuffix
    }
    return text
}